import { api } from "../api";
import type { PracticeOrg } from "../types";
import { Icons } from "../utils/icons";
import { esc } from "../utils/html";

function showToast(message: string): void {
  const existing = document.querySelector(".toast");
  if (existing) existing.remove();
  const t = document.createElement("div");
  t.className = "toast";
  t.textContent = message;
  document.body.appendChild(t);
  setTimeout(() => t.classList.add("show"), 10);
  setTimeout(() => { t.classList.remove("show"); setTimeout(() => t.remove(), 300); }, 2500);
}

export async function render(el: HTMLElement) {
  el.innerHTML = `
    <div class="page-container">
      <div class="page-header"><h1>Meine Einrichtung</h1></div>
      <div id="me-content"><div class="spinner"></div></div>
    </div>`;
  const content = el.querySelector("#me-content") as HTMLElement;

  let org: PracticeOrg;
  try {
    org = await api.practiceOrg.me();
  } catch (err: any) {
    content.innerHTML = `<div class="alert alert-error">${esc(err.message || "Profil konnte nicht geladen werden.")}</div>`;
    return;
  }

  content.innerHTML = `
    <div class="code-banner">
      <div class="code-banner__main">
        <div class="code-banner__label">Dein Einrichtungs-Code</div>
        <div class="code-banner__value-row">
          <span class="code-banner__value" id="me-code">${esc(org.code)}</span>
          <button class="btn btn-secondary btn-sm" id="me-copy" type="button">
            <span class="icon">${Icons.documentText}</span> Kopieren
          </button>
        </div>
      </div>
      <p class="code-banner__hint">
        Gib diesen Code an Schulen weiter, bei denen du als Einrichtung tätig bist.<br>
        Die Schule kann dich damit mit ihrer Planung verknüpfen.
      </p>
    </div>

    <div class="card" style="padding:1.5rem;margin-top:1.25rem">
      <h2 style="font-size:1rem;font-weight:600;margin:0 0 .75rem">Verknüpfte Schulen</h2>
      ${(org.linkedSchools && org.linkedSchools.length > 0) ? `
        <ul class="linked-schools-list">
          ${org.linkedSchools.map(s => `
            <li class="linked-school-item">
              <span class="icon">${Icons.buildingLibrary}</span>
              <div class="linked-school-info">
                <div class="linked-school-name">${esc(s.schoolName)}</div>
                <div class="linked-school-since">Verbunden seit ${new Date(s.linkedSince).toLocaleDateString("de-DE")}</div>
              </div>
            </li>`).join("")}
        </ul>
      ` : `
        <div class="empty-state empty-state--inline">
          <p style="margin:0">
            Noch keine Verknüpfung. Gib deinen Code <strong>${esc(org.code)}</strong> an Schulen weiter,
            damit diese dich verknüpfen können.
          </p>
        </div>
      `}
    </div>
  `;

  content.querySelector("#me-copy")!.addEventListener("click", async () => {
    try {
      await navigator.clipboard.writeText(org.code);
      showToast("Code in die Zwischenablage kopiert");
    } catch {
      showToast("Kopieren nicht möglich");
    }
  });
}
